import { toastError } from "../../../js/views/components/error";
import {
    appUrl,
    leadInfo,
    selectedAppointmentUnixTime,
    selectedCountry,
    setLeadInfo,
    setLeadTextId,
    visitorId,
    form,
    a2pConsentEnabled,
    smsConsentTransactional,
    smsConsentPromotional,
    termsAndPrivacyAccepted,
    setSmsConsentTransactional,
    setSmsConsentPromotional,
    setTermsAndPrivacyAccepted,
} from "../../../js/utils/variables";
import { renderUIEditInfoLead, } from "../actions/verifyInforAction";
import parsePhoneNumberFromString from "libphonenumber-js";
import { updateLeadPortal } from "../../../js/services/digitsCodeService";
import { appointmentItemsClickEventHandler } from "../actions/selectTimeActions";
import { loadAllQuestionsFlow, shouldTriggerAllQuestionsAfterValidation } from "../actions/allQuestionsFlow";
import { loadLanguageDropdownVerify, getLanguageId } from "../../views/components/languageDropdown";
import { SCREEN } from "../../utils/constants";
import { navigate } from "./movePages";
import { addressCollectionListeners } from "./addressCollectionListeners";
import { applyLeadPrefillDefaults } from "../../utils/urlPrefill";
import validator from "validator";

var verifySimpleConsentChecked = false;

export function verifyInforListeners(lead) {

    // URL-param prefill (marketing handoff) fills only the gaps — any
    // server-known lead value wins over the query string.
    lead = applyLeadPrefillDefaults(lead)

    renderUIEditInfoLead(lead)

    // Load language dropdown if enabled
    if (form?.show_language_dropdown) {
        loadLanguageDropdownVerify(lead?.language);
    }

    // Reset consent state for this flow
    verifySimpleConsentChecked = false;

    /* On click enter */
    const screenPhone = document.querySelector('.verifyInformation__container');
    if (screenPhone) {
        // Re-entering this screen must not stack a second handler.
        screenPhone.removeEventListener('keydown', handlePressEnter);
        screenPhone.addEventListener('keydown', handlePressEnter);
    }

    editInfoListener()

    // Initialize consent checkbox listeners for verify-info form
    initVerifyConsentListeners();

    // Clear any stale in-flight `.disabled` lock from a previous visit. The
    // button is never disabled for missing input — clicking it jumps to the
    // first missing field instead (onClickContinueBtn), because a dead button
    // on a form that scrolls off-screen gives no hint what's wrong.
    checkContinueBtnState();
}

function initVerifyConsentListeners() {
    const container = document.querySelector('.verifyInformation__container');
    if (!container) return;

    if (a2pConsentEnabled) {
        // A2P mode: 3 checkboxes
        const transactionalCheckbox = container.querySelector('.sms-consent-transactional-checkbox');
        const promotionalCheckbox = container.querySelector('.sms-consent-promotional-checkbox');
        const termsPrivacyCheckbox = container.querySelector('.terms-privacy-checkbox');
        const transactionalRow = container.querySelector('.sms-consent-transactional-row');
        const promotionalRow = container.querySelector('.sms-consent-promotional-row');
        const termsPrivacyRow = container.querySelector('.terms-privacy-row');

        const handleTransactionalClick = (e) => {
            e.preventDefault();
            if (transactionalCheckbox) {
                transactionalCheckbox.classList.toggle('is-checked');
                setSmsConsentTransactional(transactionalCheckbox.classList.contains('is-checked'));
                transactionalRow?.classList.remove('invalid');
                checkContinueBtnState();
            }
        };

        const handlePromotionalClick = (e) => {
            e.preventDefault();
            if (promotionalCheckbox) {
                promotionalCheckbox.classList.toggle('is-checked');
                setSmsConsentPromotional(promotionalCheckbox.classList.contains('is-checked'));
                checkContinueBtnState();
            }
        };

        const handleTermsPrivacyClick = (e) => {
            if (e.target.closest('.terms-link') || e.target.closest('.privacy-link')) {
                return;
            }
            e.preventDefault();
            if (termsPrivacyCheckbox) {
                termsPrivacyCheckbox.classList.toggle('is-checked');
                setTermsAndPrivacyAccepted(termsPrivacyCheckbox.classList.contains('is-checked'));
                termsPrivacyRow?.classList.remove('invalid');
                checkContinueBtnState();
            }
        };

        if (transactionalRow && transactionalCheckbox) {
            transactionalRow.style.cursor = 'pointer';
            transactionalRow.onclick = handleTransactionalClick;
            transactionalCheckbox.addEventListener('keydown', (e) => {
                if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); handleTransactionalClick(e); }
            });
        }
        if (promotionalRow && promotionalCheckbox) {
            promotionalRow.style.cursor = 'pointer';
            promotionalRow.onclick = handlePromotionalClick;
            promotionalCheckbox.addEventListener('keydown', (e) => {
                if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); handlePromotionalClick(e); }
            });
        }
        if (termsPrivacyRow && termsPrivacyCheckbox) {
            termsPrivacyRow.style.cursor = 'pointer';
            termsPrivacyRow.onclick = handleTermsPrivacyClick;
            termsPrivacyCheckbox.addEventListener('keydown', (e) => {
                if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); handleTermsPrivacyClick(e); }
            });
        }
    } else {
        // Simple mode: single checkbox
        const simpleCheckbox = container.querySelector('.sms-consent-simple-checkbox');
        const simpleRow = container.querySelector('.sms-consent-simple-row');

        const handleSimpleClick = (e) => {
            e.preventDefault();
            if (simpleCheckbox) {
                simpleCheckbox.classList.toggle('is-checked');
                verifySimpleConsentChecked = simpleCheckbox.classList.contains('is-checked');
                if (verifySimpleConsentChecked) {
                    setSmsConsentTransactional(true);
                    setTermsAndPrivacyAccepted(true);
                } else {
                    setSmsConsentTransactional(false);
                    setTermsAndPrivacyAccepted(false);
                }
                simpleRow?.classList.remove('invalid');
                checkContinueBtnState();
            }
        };

        if (simpleRow && simpleCheckbox) {
            simpleRow.style.cursor = 'pointer';
            simpleRow.onclick = handleSimpleClick;
            simpleCheckbox.addEventListener('keydown', (e) => {
                if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); handleSimpleClick(e); }
            });
        }
    }
}

function editInfoListener() {
    const screenPhone = document.querySelector('.verifyInformation__container');
    const verify = screenPhone.querySelector('.verify-infor__actions .verify-infor-continue__btn')
    if (verify) {
        // verifyInforListeners() runs again on every re-entry to this screen
        // (phone, validate-digits, navigation helper). Without the remove, the
        // handlers stack and a single click fires N concurrent bookings.
        verify.removeEventListener("click", onClickContinueBtn)
        verify.addEventListener("click", onClickContinueBtn)
    }
    // Prefilled contact rows render collapsed behind a summary card; the Edit
    // button re-expands the real inputs when the visitor needs to correct one.
    const editBtn = screenPhone.querySelector('.verify-infor-edit__btn');
    if (editBtn) {
        editBtn.onclick = () => {
            const body = screenPhone.querySelector('.verify-infor__body');
            body?.classList.remove('prefilled-collapsed');
            body?.querySelector('.verify-infor__summary')?.remove();
            checkContinueBtnState();
        };
    }
    document.querySelectorAll('.verifyInformation__container input').forEach((element) => {
        element.removeEventListener('input', checkContinueBtnState, false);
        element.removeEventListener('keydown', onKeyDownInput, false);
        element.addEventListener('input', checkContinueBtnState, false);
        element.addEventListener('keydown', onKeyDownInput, false);
    });
    // The gender select fires 'change', not 'input', so the generic input
    // binding above doesn't cover it (required when shown).
    const genderSelect = document.querySelector('.verifyInformation__container #genderVerify');
    if (genderSelect) {
        genderSelect.removeEventListener('change', onGenderChange, false);
        genderSelect.addEventListener('change', onGenderChange, false);
    }
    // Scope to THIS screen's DOB input: the register-new-patient page has its
    // own always-in-DOM #dobDatepicker earlier in document order, so a bare
    // id lookup binds/reads the wrong (hidden) input and the visitor's picked
    // date never submits.
    let datepicker = flatpickr(".verifyInformation__container #dobDatepicker", {
        maxDate: 'today',
        dateFormat: "M d, Y",
        altInput: true,
        altFormat: "F j, Y",
        // Prefill with the lead's existing DOB (ISO from the API) when present so
        // the verify page confirms rather than re-asks; empty otherwise.
        defaultDate: leadInfo?.date_of_birth || null,
        // The DOB input is readonly and fires no 'input' event; clear the
        // jump-to-field error state once a date is picked.
        onChange: () => {
            document.querySelector('.verifyInformation__container .dob-input')?.classList.remove('invalid');
            checkContinueBtnState();
        },
    });
}

function onGenderChange(e) {
    if (e?.target?.value) {
        document.querySelector('.verifyInformation__container .gender-input')?.classList.remove('invalid');
    }
    checkContinueBtnState();
}

async function onClickContinueBtn() {
    // The button is never disabled for missing input (a dead 50%-opacity button
    // gives no hint WHICH field is the problem, and on long forms the field is
    // off-screen entirely). Instead, clicking with something missing jumps to
    // the first offending field and shows its required/error state.
    const missing = firstInvalidField();
    if (missing) {
        missing.wrapper?.classList.add('invalid');
        missing.wrapper?.scrollIntoView({ behavior: 'smooth', block: 'center' });
        missing.focus?.focus?.({ preventScroll: true });
        return;
    }
    let loaderIcon = document.querySelector('.verify-infor-continue__btn .loader__icon');
    try {
        document.querySelector('.verify-infor-continue__btn')?.classList.add('disabled');
        document.querySelector('.verify-infor-continue__btn .loading__wrapper')?.classList.remove('hidden');
        if (loaderIcon) {
            loaderIcon.innerHTML = `<img src="${appUrl}/assets/icons/rolling.png" />`;
        }
        let nameInputDoms = document.querySelectorAll('.verifyInformation__container input');
        let fullName = nameInputDoms[0].value.trim();
        const [first_name, last_name] = splitFullName(fullName);

        // Get language value from dropdown
        const languageInput = document.querySelector('.verifyInformation__container #languageVerify');
        const selectedLanguageValue = languageInput ? languageInput.value.trim() : '';
        const languageId = selectedLanguageValue ? getLanguageId(selectedLanguageValue) : null;

        let data = {
            ...(first_name && { first_name }),
            ...(last_name && { last_name }),
            ...(nameInputDoms[1].value && nameInputDoms[1].value !== leadInfo?.email && { email: nameInputDoms[1].value }),
            ...(parsePhoneNumberFromString(nameInputDoms[2].value, selectedCountry).number !== leadInfo?.phone && { phone: parsePhoneNumberFromString(nameInputDoms[2].value, selectedCountry).number }),
            // DOB is only rendered on this page when the channel asks for it in a
            // book-first flow (see verifyInforAction.js). Submit it when present.
            ...((() => { const dob = document.querySelector('.verifyInformation__container #dobDatepicker'); return dob?.value ? { date_of_birth: dob.value } : {}; })()),
            // Gender, like DOB, is only rendered here when the channel/widget
            // asks for it (see verifyInforAction.js). Submit it when present.
            ...((() => { const g = document.querySelector('.verifyInformation__container #genderVerify'); return g?.value ? { gender: g.value } : {}; })()),
            ...(languageId && { language: languageId }),
            ...(visitorId && { visitor_id: visitorId }),
            sms_consent_transactional: smsConsentTransactional,
            sms_consent_promotional: smsConsentPromotional,
            terms_and_privacy_accepted: termsAndPrivacyAccepted,
        };

        const leadTextId = leadInfo?.text_id;
        if (leadTextId && Object.keys(data).length) {
            const updatedLead = await updateLeadPortal(leadTextId, data);
            if (updatedLead?.data) {
                // WidgetLeadResource is a strict allowlist and does NOT echo
                // date_of_birth/gender back, so merge what we just submitted
                // into the in-memory lead — otherwise flows that re-enter
                // appointmentItemsClickEventHandler with a different payload
                // (address collection, questionnaire) re-trigger the
                // verify-info detour forever.
                setLeadInfo({ ...updatedLead.data, ...data });
                if (updatedLead.data.text_id) {
                    setLeadTextId(updatedLead.data.text_id);
                }
            }
        }
        // Address is collected on its own page BEFORE the appointment is created, so
        // the booking can't be completed without it (see addressCollectionListeners).
        if (form?.appointment_channel?.collect_address) {
            navigate(SCREEN.ADDRESS_COLLECTION);
            addressCollectionListeners();
            return;
        }
        if (shouldTriggerAllQuestionsAfterValidation()) {
            loadAllQuestionsFlow();
            return;
        }
        await appointmentItemsClickEventHandler(selectedAppointmentUnixTime, data);

    } catch (error) {
        toastError(error.response?.data?.message);
        const { email } = (error.response?.data?.errors || {});

        if (email) {
            document.querySelector(".verifyInformation__container .email-input ")?.classList?.add("invalid");
        }

    } finally {
        if (loaderIcon) {
            loaderIcon.innerHTML = '<i class="ri-arrow-right-line"></i>';
        }
        document.querySelector('.verify-infor-continue__btn .loading__wrapper')?.classList.add('hidden');
        document.querySelector('.verify-infor-continue__btn')?.classList.remove('disabled');
    }
}

function checkContinueBtnState(e) {

    const container = document.querySelector(".verifyInformation__container");

    if (container) {
        const target = e?.target;
        let value = target?.value

        const classNames = [
            { className: "full_name-input", type: "full_name-input" },
            { className: "phone-input", type: "phone-input" },
        ];

        const inputErr = classNames
            .filter(({ className }) => target?.closest(`.${className}`))
            .map(({ type }) => type);


        inputErr.forEach((type) => {
            const element = container.querySelector(`.${type}`);
            if (type === "full_name-input") {
                if (value && !validateFullName(value)) {
                    value = "";
                }
            }
            if (value) {
                element?.classList?.contains("invalid") && element.classList.remove("invalid");
            } else {
                !element?.classList?.contains("invalid") && element.classList.add("invalid");
            }
        });
    }

    // The button is intentionally NEVER disabled for missing input — clicking
    // it jumps to the first missing field instead (onClickContinueBtn). The
    // `.disabled` class is only used as an in-flight lock while a submission
    // request is running; make sure typing never strands it on.
    if (validateData()) {
        document.querySelector('.verifyInformation__container .verify-infor-continue__btn')?.classList.remove('disabled');
    }
}


function onKeyDownInput(event) {
    if (event.key === 'Tab') {
        event.stopPropagation();
    }
}


function handlePressEnter(event) {
    event.stopPropagation();
    if (event.key === 'Enter' && !document.querySelector(`.verifyInformation__container .verify-infor-continue__btn`).classList.contains('disabled')) {
        document.querySelector(`.verifyInformation__container .verify-infor-continue__btn`).click();
    }
}

export function resetPageRegisterNewPatientsFormData() {
    document.querySelectorAll('.verifyInformation__container input').forEach((element) => { element.value = ''; });
}


function isValidEmail(email) {
    // Use the same validator the rest of the widget uses. The old hand-rolled
    // regex capped the TLD at 4 characters, so anyone on .online / .clinic /
    // .dental / .health / .practice failed validation and got a permanently
    // disabled Continue button with no error text — they simply could not book.
    return validator.isEmail((email || '').trim());
}

function validateFullName(fullName) {
    return fullName.split(" ")?.filter(i => !!i).length >= 2;
}

// Returns the first field blocking submission as { wrapper, focus } (wrapper
// gets `.invalid` + scrolled into view, focus gets keyboard focus), or null
// when the form is submittable. Field order matches the rendered order so the
// jump-on-click behavior in onClickContinueBtn walks the page top to bottom.
function firstInvalidField() {
    const container = document.querySelector('.verifyInformation__container');
    if (!container) return null;

    const fullNameDom = container.querySelector('.full_name-input input');
    if (!validateFullName(fullNameDom?.value || '')) {
        return { wrapper: container.querySelector('.full_name-input'), focus: fullNameDom };
    }

    const emailDom = container.querySelector('.email-input input');
    if (emailDom?.value && !isValidEmail(emailDom.value)) {
        return { wrapper: container.querySelector('.email-input'), focus: emailDom };
    }
    // Email is optional; once it's empty or valid again, drop the error state.
    container.querySelector('.email-input')?.classList?.remove("invalid");

    const phoneDom = container.querySelector('.phone-input input');
    if (!phoneDom?.value) {
        return { wrapper: container.querySelector('.phone-input'), focus: phoneDom };
    }

    // DOB is required only when the channel asks for it (field rendered).
    // flatpickr altInput hides the real #dobDatepicker, so focus its visible
    // sibling input instead.
    const dobDom = container.querySelector('#dobDatepicker');
    if (dobDom && !dobDom.value) {
        const dobWrapper = container.querySelector('.dob-input');
        return { wrapper: dobWrapper, focus: dobWrapper?.querySelector('input.form-control') || dobDom };
    }

    // Gender, same rule: required only when rendered — an empty value here
    // would send the visitor back into the verify-info detour forever.
    const genderDom = container.querySelector('#genderVerify');
    if (genderDom && !genderDom.value) {
        return { wrapper: container.querySelector('.gender-input'), focus: genderDom };
    }

    if (a2pConsentEnabled) {
        if (!smsConsentTransactional) {
            return { wrapper: container.querySelector('.sms-consent-transactional-row') };
        }
        if (!termsAndPrivacyAccepted) {
            return { wrapper: container.querySelector('.terms-privacy-row') };
        }
    }

    return null;
}

export function validateData() {
    return !firstInvalidField();
}


function splitFullName(fullName) {
    let nameParts = fullName.split(" ");
    let first_name = nameParts[0];
    let last_name = nameParts.slice(1).join(" ");
    return [first_name, last_name];
}
